module.exports = __webpack_public_path__ + "static/media/company-profile-banner1.c64454eb.png";